<template>
  <nav class="breadcrumbs" v-if="list.length">
    <ul>
      <li v-for="(route, i) in list" :key="i">
        <router-link
          active-class="active"
          :to="route.path"
          :tag="i != list.length - 1 ? 'a' : 'strong'"
          :event="i != list.length - 1 ? 'click' : ''"
        >
          {{ route.label }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    labels: Array
  },
  data() {
    return {
      list: []
    };
  },
  watch: {
    $route() {
      this.setLevels();
    },
    labels() {
      this.setLevels();
    }
  },
  created() {
    this.setLevels();
  },
  methods: {
    link(router) {
      let path = "";
      Object.keys(this.$route.params).forEach(e => {
        path = router.path.replace(`:${e}`, this.$route.params[e]);
      }, this);

      return path;
    },
    setLabels(index) {
      return this.labels.length - 1 >= index ? this.labels[index] : false;
    },
    setLevels() {
      const vm = this;
      const list = [];
      let i = 0;

      vm.$route.matched.forEach(router => {
        if (router.meta.breadcrumb) {
          list.push({
            label: this.setLabels(i) || router.meta.breadcrumb,
            path: this.link(router)
          });

          i += 1;
        }
      });

      vm.list = list;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/layout/Breadcrumbs.vue